/**
 * ReportState Style01 - State report display (read-only)
 */
import type { TraitControlProps } from './types'

export function ReportStateStyle01({ state }: TraitControlProps) {
  const keys = Object.keys(state ?? {}).filter((k) => !k.startsWith('_'))
  const entries = keys.slice(0, 5).map((k) => `${k}: ${String(state?.[k] ?? '--')}`)

  return (
    <div className="smart-home-automation-field">
      <label>ReportState</label>
      <div className="trait-reportstate-style01__list">
        {entries.length > 0 ? entries.map((e, i) => <div key={i}>{e}</div>) : <span>No state</span>}
      </div>
    </div>
  )
}
